import React from "react";

function Resume() {
  return (
    <div id="resume">
      <div className="button">
        <a download href="/files/resume.pdf" target="_blank">
          <span>Download my resume </span>
        </a>
      </div>

      <div className="wrapper">
        <div id="education">
          <h1 className="section-title">EDUCATION</h1>
          <h2 className="title">B.S. Computer Science and Technology</h2>
          <h3 className="subtitle">August 2018 - June 2022 (expected)</h3>
          <ul className="bullets">
            <li>
              Currently on my 5th semester, but I will be on my 7th next
              semester since I have been advancing subjects.
            </li>
            <li>
              <span className="bold">Relevant courses:</span> Oriented-Object
              programming, Interactive Design fundamentals, Computational
              Mathmatics, Data Structures, Databases, Operating Systems, Advance
              Programming (currently), Progamming Languages (currently).
            </li>
            <li>
              <span className="bold">Average:</span> 95 / 100
            </li>
            <li>
              <span className="bold">Major GPA: </span> 3.6
            </li>
          </ul>
        </div>
        <div id="experience">
          <h1 className="section-title">PROJECTS</h1>
          <div className="work">
            <h2 className="title">REACT prototype for ALVAP Store | 2020</h2>
            <h3 className="subtitle">
              Prototype designed with React for the frontend and with the
              implementation of MySQL for the backend.
            </h3>
            <ul className="bullets">
              <li>
                Frontend developed with <span className="bold">React </span>and{" "}
                <span className="bold">Typescript </span>for custom styled
                elements and better readability.
              </li>
              <li>Backend implements an SQL database.</li>
              <li>Hosted on a Heruko server.</li>
            </ul>
          </div>
          <div className="work">
            <h2 className="title">Top down view 2D videogame | 2020</h2>
            <h3 className="subtitle">
              Top down shooter with 2 levels, enemies and characters.
            </h3>
            <ul className="bullets">
              <li>
                Implemented a character selection, level selection and save &
                load functionality.
              </li>
              <li>
                Implemented A* pathfinding to determine the movement of enemies
                and implemented an FSM for the bosses’ behavior.
              </li>
              <li>
                Developed in <span className="bold">Unity </span>
                and <span className="bold">C#</span>.
              </li>
            </ul>
          </div>
          <div className="work">
            <h2 className="title">Mobile app prototype | 2019</h2>
            <h3 className="subtitle">
              Website and app-prototype, that saves data locally, to simulate
              the interaction and functionality of a real startup device called
              Knocki.
            </h3>
            <ul className="bullets">
              <li>
                I leaded a team in order to develop an appealing and unique
                design interface and, thanks to many beta tests, we made it easy
                to understand and simple to use.
              </li>
              <li>
                Developed in <span className="bold">HTML5 </span> and{" "}
                <span className="bold">CSS3</span>, functionality implemented
                with JavaScript.
              </li>
            </ul>
          </div>
        </div>
        <div id="awards">
          <h1 className="section-title">HONORS AND AWARDS</h1>
          <div className="award">
            <h2 className="title">
              Academic-Talent scholarship | Tec de Monterrey, CCM
            </h2>
            <ul className="bullets">
              <li>
                Received for my high school’s distinctions and my above average
                grade in my entrance examination.
              </li>
            </ul>
          </div>
          <div className="award">
            <h2 className="title">
              2nd Place in regional science competition| ExpoCiencias, 2018
            </h2>
            <ul className="bullets">
              <li>
                Leaded a team in order to create a clean energy protype
                generator that took advantage of the electromagnetic and
                piezoelectric phenomena.
              </li>
              <li>
                We presented in front of judges and attended a regional Expo,
                where we were awarded the 2nd place in the sustainable energy
                category.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Resume;
